import React, { useEffect } from "react";

import { Spacer } from "components/base/Spacer";
import { commentTypes } from "const";
import NotesForm from "./NotesForm";
import NotesList from "./NotesList";


export default ({
    notesList,
    notesLoading,
    isFetched,
    accountId,
    getAccountNoteList,
    removeAccountNote,
    createAccountNote
}) => {
    useEffect(() => {
        if (accountId) {
            getAccountNoteList(accountId);
        }
    }, [accountId]);

    return (
        <>
            <Spacer />
            <NotesForm
                {...{
                    commentTypes,
                    notesList,
                    notesLoading,
                    accountId,
                    getAccountNoteList,
                    createAccountNote,
                }}
            />
            <Spacer size={40} />
            <NotesList
                {...{
                    commentTypes,
                    notesLoading,
                    notesList,
                    accountId,
                    isFetched,
                    getAccountNoteList,
                    removeAccountNote
                }}
            />
            <Spacer size={40} />
        </>
    );
};